import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, UserPlus, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Register = () => {
  const { register, user } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/account", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success(`Welcome to MAKEBA, ${form.name.split(" ")[0]}!`);
      nav("/account", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="register-page" className="container-x py-16 md:py-24">
      <div className="max-w-md mx-auto">
        <div className="w-14 h-14 bg-[#EC008C] text-white flex items-center justify-center mb-6 rounded-full">
          <UserPlus size={22} />
        </div>
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#EC008C] font-semibold mb-3">Create Account</div>
        <h1 className="font-display font-light text-4xl md:text-5xl text-black tracking-tight">
          Join the <span className="font-black">crew.</span>
        </h1>
        <p className="mt-3 text-[#4A4A4A] font-light">Save your favorites, track orders, and get 10% off your first purchase.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase font-semibold text-black mb-2 block">Full name</label>
            <input
              data-testid="register-name"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full px-4 py-3 border border-black focus:outline-none focus:border-[#EC008C]"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase font-semibold text-black mb-2 block">Email</label>
            <input
              data-testid="register-email"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full px-4 py-3 border border-black focus:outline-none focus:border-[#EC008C]"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase font-semibold text-black mb-2 block">Password (min 6 chars)</label>
            <input
              data-testid="register-password"
              type="password"
              required
              minLength={6}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full px-4 py-3 border border-black focus:outline-none focus:border-[#EC008C]"
            />
          </div>
          <button data-testid="register-submit" disabled={loading} className="w-full btn-primary justify-center disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <>Create account <ArrowRight size={14} /></>}
          </button>
        </form>

        <div className="mt-8 border-t border-[#E5E2DA] pt-8 text-center">
          <p className="text-sm text-[#4A4A4A] font-light">Already have an account?</p>
          <Link to="/login" data-testid="link-login" className="mt-2 inline-block btn-outline">
            Sign in
          </Link>
        </div>
      </div>
    </main>
  );
};

export default Register;
